var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"x-small":"","color":"teal lighten-1","text-color":"white"}},[_vm._v("Zewnętrzny")])
}
var staticRenderFns = []

export { render, staticRenderFns }